import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/staking.svg'
import _imports_1 from '@/assets/images/adaIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-07a349f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 mb-32 mt-16" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-4"
}, null, -1))
const _hoisted_3 = { class: "account-details-delegations-tab__transaction-details" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-4"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullWrapContainer = _resolveComponent("FullWrapContainer")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_AmountText = _resolveComponent("AmountText")!
  const _component_LabeledItem = _resolveComponent("LabeledItem")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_BlockCardLayoutBoxedItem = _resolveComponent("BlockCardLayoutBoxedItem")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createBlock(_component_a_row, { class: "ant-row ant-row-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_List, {
          "total-items": _ctx.accountDetailsForDisplay?.delegations?.length,
          "data-source": _ctx.accountDetailsForDisplay?.delegations,
          "show-load-more": false,
          "is-loading": _ctx.isLoading
        }, {
          renderItem: _withCtx(({ item, index }) => [
            _createVNode(_component_a_list_item, { class: "pb-4 pt-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      align: "top",
                      gutter: 32
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: 24,
                          sm: 14
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FullWrapContainer, {
                              content: item?.transaction?.hash,
                              title: _ctx.t('transaction hash')
                            }, {
                              prefix: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 2
                            }, 1032, ["content", "title"]),
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", null, _toDisplayString(_ctx.formatDateTime(item?.transaction?.block?.timestamp)), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          sm: 5
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createElementVNode("b", null, [
                              (item?.transaction?.amount)
                                ? (_openBlock(), _createBlock(_component_AmountText, {
                                    key: 0,
                                    class: "d-inline",
                                    amount: _ctx.convertAmountToAda(item?.transaction?.amount)
                                  }, null, 8, ["amount"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          sm: 5
                        }, {
                          default: _withCtx(() => [
                            (
                      _ctx.accountDetailsForDisplay?.delegations &&
                      _ctx.accountDetailsForDisplay?.delegations[index + 1] &&
                      _ctx.accountDetailsForDisplay?.delegations[index + 1]
                        ?.poolChange?.hash
                    )
                              ? (_openBlock(), _createBlock(_component_LabeledItem, {
                                  key: 0,
                                  class: "mb-4"
                                }, {
                                  "inline-label": _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t("from pool")), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_FullWrapContainer, {
                                      title: _ctx.t('from pool'),
                                      content: 
                        _ctx.formatPoolLabel(
                          _ctx.accountDetailsForDisplay?.delegations[index + 1]
                            ?.poolChange.name,
                          _ctx.accountDetailsForDisplay?.delegations[index + 1]
                            ?.poolChange.ticker,
                          _ctx.accountDetailsForDisplay?.delegations[index + 1]
                            ?.poolChange.hash
                        )
                      ,
                                      "enable-copy-to-clipboard": false
                                    }, null, 8, ["title", "content"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (item?.poolChange?.hash)
                              ? (_openBlock(), _createBlock(_component_LabeledItem, { key: 1 }, {
                                  "inline-label": _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t("to pool")), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_FullWrapContainer, {
                                      placement: "topLeft",
                                      title: _ctx.t('to pool'),
                                      content: 
                        _ctx.formatPoolLabel(
                          item?.poolChange.name,
                          item?.poolChange.ticker,
                          item?.poolChange.hash
                        )
                      ,
                                      "enable-copy-to-clipboard": false
                                    }, null, 8, ["title", "content"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["total-items", "data-source", "is-loading"])
      ])
    ]),
    _: 1
  }))
}